module.exports = "<p>\n  crypto works!\n  <button nz-button [nzType]=\"'default'\" (click)=\"enc()\">\n    <span>Default</span>\n  </button>\n  {{pubKey}}\n</p>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/crypto/crypto.component.html
// module id = ./src/app/crypto/crypto.component.html
// module chunks = main